import Vue from 'vue';
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// #region Pro icons
// Regular icons
import {
	faUser,
	faUserAlt,
	faPlus,
	faSearch,
} from '@fortawesome/pro-regular-svg-icons';
// #endregion

// #region Free icons
import {
	faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
// #endregion

faLibrary.add(
	// Regular
	faUser,
	faUserAlt,
	faPlus,
	faSearch,

	// Solid
	faChevronRight,
);

// Register the component globally
Vue.component('FontAwesomeIcon', FontAwesomeIcon);